
import { defineComponent, onMounted, Ref, ref } from "vue";
import { useRoute } from "vue-router";
import { faqs } from "@/core/data/faqs"; // dummy data

export default defineComponent({
  name: "getting-started-page",
  setup() {
    const route = useRoute();

    const articles: Ref<{ title: string; summary: string }[]> = ref([]);

    onMounted(() => {
      switch (route.params.category.toString()) {
        case "umum":
          articles.value = faqs["umum"];
          break;
        case "peperiksaan":
          articles.value = faqs["peperiksaan"];
          break;
        case "kenaikan-pangkat":
          articles.value = faqs["kenaikan-pangkat"];
          break;
      }
    });

    faqs;
    return { articles };
  },
});
